import _ from 'lib/underscore';
import $ from 'jquery';
import 'lib/autosize';
import {ReviewList} from "./reviewlist";
import {Likers, TYPE_REVIEW_LIKE, TYPE_SALE_LIKE} from "./likers";
import {ReviewComment} from "./reviewcomment";
import {ensureLoggedIn, UserInfo} from "core/auth";
import {Notifier} from "core/widgets/notifier";
import {siteUrl} from "core/utils/url";
import {highlightUrls} from "core/utils/url";
import * as langUtils from "../../../../core/utils/lang";
import {MODAL_REVIEW_EDIT, MODAL_QUESTION_EDIT} from "../../../../core/modals";

export class ReviewItem {
	/** @var {ReviewList} */
	_parent = null;

	constructor(data) {
		this.data = ko.observable(data);
		this._parent = data.parent;
		this._showImage = this._parent.showImages;
		this._showVideo = this._parent.showVideos;
		this._author = new UserInfo(data.author);
		this._comments = ko.observableArray(data.comments
			? _.map(data.comments, d => {d.parent = this; return new ReviewComment(d)})
			: []);
		this._newComment = new NewComment(this, comment => {
			this._comments.push(comment);
		});
		this._likers = new Likers(
			this.id,
			data.likes,
			data.my_like,
			data.is_sale ? TYPE_SALE_LIKE : TYPE_REVIEW_LIKE
		);
		this._onClick = $.Callbacks();

        this.collapsed = ko.observable(this._showImage);
        this.titleUrl = ko.pureComputed(
        	() => this._parent.isDetails
				? null
				: (this.data().is_question ? this.data().url : this.data().package_info.order_id)
		);
		this.displayHtml = ko.pureComputed(() => highlightUrls(this.data().text));
		this.isBodyLess = ko.pureComputed(() => !this.data().text);
        this.isClosed = ko.observable(data.closed);
        this.isAuthorHidden = !this._showImage && data.author.id === 1084; // Hide author if it is Alena

		this.handleClick = this.handleClick.bind(this);
		this.afterRender = this.afterRender.bind(this);

		if(zde.currentUser !== null && zde.currentUser.roleId == 2) {
            this._forWhom = ko.observable(data.for_whom);
            this.forWhomTitle = ko.pureComputed(() => {
                let result;
                switch (parseInt(this._forWhom())) {
                    case 1:
                        result = 'Виден всем';
                        break;
                    case 2:
                        result = 'Украина';
                        break;
                    case 3:
                        result = 'Россия';
                        break;
                    case 4:
                        result = 'Только участники';
                        break;
                    default:
                        result = 'Виден всем';
                        break;
                }
                return result;
            });

            this.isClosed.subscribe(() => this.changeClosed());
        }
	}

	get id() {
		return this.data().id;
	}

	/** @return {UserInfo} */
	get author() {
		return this._author;
	}

	/** @return {ReviewComment[]} */
	get comments() {
		return this._comments();
	}

	/** @return {NewComment} */
	get newComment() {
		return this._newComment;
	}

	/** @return {Likers} */
	get likers() {
		return this._likers;
	}

	/** @return {boolean} */
	get showImage() {
		return this._showImage;
	}

	/** @return {boolean} */
	get showVideo() {
		return this._showVideo;
	}

	/** @return {boolean} */
	get isDetailsPage() {
		return this._parent.isDetails;
	}

	/** @return string|null */
	getVideoUrl(autoplay=false) {
		let url = this.data().video_url;
		if (url && autoplay) {
			url += '?autoplay=1';
		}
		return url;
	}

	handleClick(data, e) {
		const $target = $(e.target);
		const $currentTarget = $(e.currentTarget);

		if (this.data().is_sale) {
			// Allow default browser action
			return true;
		}

		if (($target.is('a') || $currentTarget.hasClass('direct-link')) && !$target.hasClass('review-text-wrapper')) {
            // Allow default browser action
            return true;
        }

		this._onClick.fireWith(this, [this]);
        return false;
	}

	afterRender(anchor) {
		if(!this.showImage) {
            const $element = $(anchor).parents('.review-item');
            const $userInfo = $element.find('.review-header .user-info');
            const $likeButton = $element.find('.review-main .review-like');

            const $inlineContainer = $('<div class="inline-container"></div>');

            $userInfo.addClass('user-info-inline');
            $likeButton.addClass('review-like-inline');
            $inlineContainer.append($userInfo).append($likeButton);
            if(this.isBodyLess()) {
                $element.find('.question-info-block .question-title').append($inlineContainer);
            } else {
            	$element.find('.review-text').append($inlineContainer);
			}
        }
	}

	onClick(handler) {
		this._onClick.add(handler);
	}

	offClick(handler) {
		this._onClick.remove(handler);
	}

	expand() {
		this.collapsed(false);
	}

	remove() {
        if(confirm('Вы действительно хотите удалить отзыв?')) {
            this._parent.deleteItem(this);
        }
	}

	edit() {
		if(this.data().is_question) {
            MODAL_QUESTION_EDIT.show(this.id, response => {
                if(response && response.updatedValues) {
                    const data = this.data();

                    data.title = response.updatedValues.product_name;
                    data.text = response.updatedValues.text;
                    data.category_id = parseInt(response.updatedValues.category_id);
                    if(response.updatedValues.date) {
                        data.date = response.updatedValues.date;
                        data.date_human = response.updatedValues.date_human;
                    }

                    this.data(data);

                    if(!this.showImage) {
                    	this._forceRedraw();
					}
                }
			});
		} else {
            MODAL_REVIEW_EDIT.show(this.id, null, {}, response => {
                if(response && response.updatedValues) {
                    const data = this.data();

                    if(response.updatedValues.product_name) {
                        data.title = response.updatedValues.product_name;
                    }
                    data.text = response.updatedValues.text;
                    data.category_id = parseInt(response.updatedValues.category_id);
                    data.forsale = parseInt(response.updatedValues.forsale);
                    data.rating = parseInt(response.updatedValues.rating);
                    if(response.updatedValues.image_preview) {
                        data.preview = response.updatedValues.image_preview;
                    }

                    this.data(data);

                    if(!this.showImage) {
                        this._forceRedraw();
                    }
                }
            });
		}
	}

	changeForWhom() {
        $.post(siteUrl('reviews/changeForWhom'),
			{
				id: this.id,
				state: this._forWhom()
			},
			response => {
            	if(response.success) {
                	this._forWhom(response.state);
        	    }
        	},
			'json'
		);
	}

	changeClosed() {
		$.post(
			siteUrl('reviews/changeClosed'),
			{
				id: this.id,
				state: this.isClosed() ? 1 : 0
			},
            response => {},
			'json'
		);
	}

	/** @param {ReviewComment} comment */
	deleteComment(comment) {
        $.post(siteUrl('reviews/delete_comment'),
            {id: comment.id},
            response => {
                if(response.success) {
                    this._comments.remove(comment);
                } else {
                	Notifier.error();
				}
            },
            'json'
        );
	}

	_forceRedraw() {
		this._parent.reviews.replace(this, new ReviewItem(this.data()));
	}
}

class NewComment {
	text = ko.observable('');

	inputHasFocus = ko.observable(false);
	isSaveButtonVisible = null;

	constructor(review, callback) {
		this._review = review;
		this._textTrimmed = this.text.trimmed();
		this._onSave = $.Callbacks();
		if (callback) {
			this._onSave.add(callback);
		}
        this.isSaveButtonVisible = ko.computed(() => {
            // return this.inputHasFocus() && this.text();
            return this._textTrimmed().length > 0;
        });
	}

	save() {
		if (!this._textTrimmed().length) {
			return;
		}
		ensureLoggedIn(user => {
			const parentId = this._review.id;
			const text = this._textTrimmed();
			let postData;

			this.text('');
			if (!this._review.data().is_sale) {
				postData = {
					text,
					parent_id: parentId,
					comment_type: 'review',
				};
				$.post(siteUrl('reviews/save_comment'), postData, null, 'json')
					.fail(Notifier.errorXHR)
					.done(response => {
						if (!response || !response.success) {
							Notifier.error(response ? response.error : null);
						} else {
							const comment = new ReviewComment({
								id: response.id,
								text: text,
								author: user,
								date: response.date,
								date_human: response.date_human,
								likes: 0,
								my_like: false,
								is_editable: true,
								parent: this._review
							});
							this._onSave.fire(comment);
							Notifier.success("Комментарий отправлен");
						}
					});
			} else {
				postData = {
					comments_page_id: parentId,
					comments_content: text
				};
				$.post(siteUrl('blog/comments_save'), postData, null, 'json')
					.fail(Notifier.errorXHR)
					.done(response => {
						if (!response || !response.success) {
							Notifier.error(response ? response.error : null);
						} else {
							const comment = new ReviewComment({
								id: response.comment.comments_id,
								text: text,
								author: user,
								date: response.comment.comments_date,
								date_human: response.comment.comments_date_human,
								likes: null,
								my_like: false,
								is_editable: false,
								parent: this._review
							});
							this._onSave.fire(comment);
							Notifier.success("Комментарий отправлен");
						}
					});
			}
		});
	}

	onSave(callback) {
		this._onSave.add(callback);
	}
}



// WEBPACK FOOTER //
// ./modules/reviews/common/model/reviewitem.js